export default __webpack_public_path__ + "static/media/gallery-wip-handle_05.b22e0d2a.jpg";